import React, { useEffect, useState } from 'react';
import { getShipmentImages } from '../api';
import ImageViewer from './ImageViewer';
import { useT } from '../i18n';

export default function InsideImagesModal({ shipmentId, tracking, onClose }) {
  const t = useT();
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);
  const [viewer, setViewer] = useState(null);

  useEffect(() => {
    getShipmentImages(shipmentId)
      .then(data => { setImages(data); if (data.length > 0) setSelected(data[0].image_url); })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [shipmentId]);

  return (
    <>
    <div style={s.overlay} onClick={onClose}>
      <div style={s.modal} onClick={e => e.stopPropagation()}>
        <div style={s.header}>
          <div>
            <div style={s.title}>{t('Inside photos')}</div>
            {tracking && <div style={s.tracking}>{tracking}</div>}
          </div>
          <button onClick={onClose} style={s.closeBtn}>×</button>
        </div>

        {loading ? (
          <div style={s.empty}>{t('Loading...')}</div>
        ) : images.length === 0 ? (
          <div style={s.empty}>{t('No inside photos')}</div>
        ) : (
          <>
            {/* Main image — click to zoom/rotate */}
            <div style={s.mainImgWrap} onClick={() => setViewer(selected)}>
              <img src={selected} alt="inside" style={s.mainImg} />
              <div style={s.zoomHint}>
                <span className="material-symbols-outlined" style={{fontSize:14}}>zoom_in</span>
                {t('Click to zoom / rotate')}
              </div>
            </div>
            {/* Thumbnails */}
            {images.length > 1 && (
              <div style={s.thumbRow}>
                {images.map((img, i) => (
                  <img
                    key={img.id}
                    src={img.image_url}
                    alt={`inside ${i+1}`}
                    onClick={() => setSelected(img.image_url)}
                    style={{
                      ...s.thumb,
                      border: selected === img.image_url
                        ? '2px solid var(--accent)'
                        : '2px solid rgba(15,23,42,0.10)',
                    }}
                  />
                ))}
              </div>
            )}
            <div style={s.count}>{t('{n} inside photos', { n: images.length })}</div>
          </>
        )}
      </div>
    </div>
    {viewer && (
      <ImageViewer
        src={viewer}
        alt="inside"
        title={tracking ? t('Inside · {tracking}', { tracking }) : t('Inside')}
        onClose={() => setViewer(null)}
      />
    )}
    </>
  );
}

const s = {
  overlay: { position:'fixed', inset:0, background:'rgba(15,23,42,0.55)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:200 },
  modal: { background:'var(--bg-secondary)', border:'1px solid rgba(15,23,42,0.10)', borderRadius:14, padding:20, maxWidth:'92vw', width:480 },
  header: { display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:16 },
  title: { fontSize:14, fontWeight:700, color:'var(--text-primary)', marginBottom:4 },
  tracking: { fontVariantNumeric:"tabular-nums",fontWeight:600, fontSize:12, color:'var(--accent)', fontWeight:600 },
  closeBtn: { background:'none', border:'none', color:'var(--text-muted)', cursor:'pointer', fontSize:24, lineHeight:1, padding:0 },
  mainImgWrap: { borderRadius:10, overflow:'hidden', marginBottom:12, background:'rgba(15,23,42,0.15)', position:'relative', cursor:'zoom-in' },
  mainImg: { width:'100%', maxHeight:'60vh', objectFit:'contain', display:'block' },
  zoomHint: { position:'absolute', bottom:8, right:8, display:'inline-flex', alignItems:'center', gap:4, padding:'4px 8px', background:'rgba(15,23,42,0.75)', color:'#e5e7eb', fontSize:11, fontWeight:500, borderRadius:6, pointerEvents:'none' },
  thumbRow: { display:'flex', gap:8, flexWrap:'wrap', marginBottom:10 },
  thumb: { width:64, height:64, objectFit:'cover', borderRadius:6, cursor:'pointer', transition:'border 0.15s' },
  count: { fontSize:12, color:'var(--text-muted)', textAlign:'center' },
  empty: { padding:'32px', textAlign:'center', color:'var(--text-muted)', fontSize:13 },
};
